import { render, staticRenderFns } from "./SearchRascunho.vue?vue&type=template&id=3d2adfc6&"
import script from "./SearchRascunho.vue?vue&type=script&lang=js&"
export * from "./SearchRascunho.vue?vue&type=script&lang=js&"
import style0 from "./SearchRascunho.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports